import {gsap} from "gsap";
import {TheCage} from "../../TheCage";
import {TheCageSymbol, TheCageSymbolStates} from "../../reels/TheCageSymbol";
import {SymbolUtils} from "../../utils/SymbolUtils";
import {TheCageStatics} from "../../config/TheCageStatics";
import {NormalWin} from "../maingame/win/NormalWin";
import {WinConfig} from "../../utils/WinConfigUtil";
import {TheCageSound} from "../../sound/TheCageSound";
import {SimplePresentationRunnerController} from "../../../core/winpresentation/SimplePresentationRunner";


/**
 * Created by jonas on 2022-01-12.
 */

export class FreeSpinWin extends NormalWin {

    name:string = "FreeSpinWin";
    private winSound:string;
    private winSweep:string;

    constructor() {
        super();
    }

    shouldRun():boolean {
        return true;
    }

    protected getInitialWin(isBigWin:boolean, lastLevelName:string, controller:SimplePresentationRunnerController, callbackFixHack:{finished:boolean}):gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline({onComplete: () => {
                if (!callbackFixHack.finished) {
                    callbackFixHack.finished = true;
                    controller.finish();
                    controller.setSkipCallback();
                }
            }
        });
        tl.add(() => controller.setSkipCallback(() => {
            tl.timeScale(2);
            TheCage.soundPlayer.stopSound(TheCageSound.WIN_SWEEP_TINY);
            TheCage.soundPlayer.stopSound(TheCageSound.WIN_SWEEP_SMALL);
            TheCage.soundPlayer.stopSound(TheCageSound.WIN_SWEEP_MEDIUM);
            TheCage.soundPlayer.stopSound(TheCageSound.WIN_SWEEP_LARGE);
            TheCage.soundPlayer.stopSound(TheCageSound.WIN_BOTHWAYS_SWEEP);
        }));

        // setup
        const noWinSymbols = SymbolUtils.getAllFreespinSymbolsWithState(TheCageSymbolStates.NO_WIN);
        const winSymbols = SymbolUtils.getAllFreespinSymbolsWithStateByReel(TheCageSymbolStates.WIN_TINY);
        const winHighlight = TheCageSymbolStates.WIN_HIGHLIGHT_LARGE;
        const winExplosion = TheCageSymbolStates.WIN_EXPLODE_LARGE;
        const winReverse = TheCageSymbolStates.WIN_REVERSE_LARGE;

        // lord have mercy :skull:
        const winLineAmountData = this.getWinWayAmountData();
        const leftLines = winLineAmountData.filter((line) => line.leftToRight)
        const leftToRightSymbols = winSymbols.map((reel) => reel.filter((sym) => leftLines.some((line) => line.positions.some( (pos) => pos.column == sym.reelId && pos.row == sym.reelPosition ))));
        const rightLines = winLineAmountData.filter((line) => !line.leftToRight)
        const rightToLeftSymbols = winSymbols.map((reel) => reel.filter((sym) => rightLines.some((line) => line.positions.some( (pos) => pos.column == sym.reelId && pos.row == sym.reelPosition ))));
        const bothWaySymbols = leftToRightSymbols.map((reel, index) => reel.filter((sym) => rightToLeftSymbols[index].some((sym2) => sym2.reelId == sym.reelId && sym2.reelPosition == sym.reelPosition )) )
        const isBothWays = bothWaySymbols.some((reel) => reel.length > 0);

        const delay = winLineAmountData.some((line) => line.betWin.length == 9)
                      ? TheCageStatics.WIN_SYMBOL_DELAY * 2
                      : TheCageStatics.WIN_SYMBOL_DELAY;

        // left to right
        const winSymbolsLeftTl = gsap.timeline();
        if (isBothWays) {
            tl.add(() => TheCage.soundPlayer.playSound(TheCageSound.WIN_BOTHWAYS_SWEEP));
        } else if (leftLines.length > 0) {
            if (rightLines.length == 0) {
                tl.add(() => TheCage.soundPlayer.playSound(this.winSound));
            } else {
                tl.add(() => TheCage.soundPlayer.playSound(this.winSweep))
            }
        }
        for (let i = 0; i < 9; i++) {
            const result: gsap.core.Timeline[] = [];
            //Reverse to add the symbols bottom to top.
            for (let sym of leftToRightSymbols[i]) {
                let tl;
                if ((<TheCageSymbol>sym.positionable).symbolName == "WS") {
                    tl = TheCage.freeSpinReelView.features.useStickyWild();
                } else {
                    tl = (<TheCageSymbol>sym.positionable).getStateAnimation(winHighlight);
                }
                result.push(tl);
            }
            if (result.length > 0) {
                winSymbolsLeftTl.add(result, `<${delay}`);
            }
        }
        tl.add(winSymbolsLeftTl)

        // both way lines
        if (isBothWays) {
            tl.add(() => {}, '>0.5');
            const unhighlightSymbolsTl = gsap.timeline();
            for (let i = 0; i < 9; i++) {
                const result: gsap.core.Timeline[] = [];
                //Reverse to add the symbols bottom to top.
                for (let sym of bothWaySymbols[i]) {
                    if ((<TheCageSymbol>sym.positionable).symbolName != "WS") {
                        result.push((<TheCageSymbol>sym.positionable).getStateAnimation(winReverse));
                        result.push((<TheCageSymbol>sym.positionable).getStateAnimation(TheCageSymbolStates.NO_WIN));
                    }
                }
                if (result.length > 0) {
                    unhighlightSymbolsTl.add(result, `<${delay / 2}`);
                }
            }
            tl.add(unhighlightSymbolsTl);
        }

        // right to left
        const winSymbolsRightTl = gsap.timeline();
        if (rightLines.length > 0 && !isBothWays) {
            if (leftLines.length > 0) {
                tl.add(() => TheCage.soundPlayer.playSound(this.winSound), '>0.2');
                tl.add(() => {}, '<-0.2');

            } else {
                tl.add(() => TheCage.soundPlayer.playSound(this.winSound));
            }
        }
        for (let i = 8; 0 <= i; i--) {
            const result: gsap.core.Timeline[] = [];
            //Reverse to add the symbols bottom to top.
            for (let sym of rightToLeftSymbols[i]) {
                let tl;
                if ((<TheCageSymbol>sym.positionable).symbolName == "WS") {
                    tl = TheCage.freeSpinReelView.features.useStickyWild();
                } else {
                    tl = (<TheCageSymbol>sym.positionable).getStateAnimation(winHighlight);
                }
                result.push(tl);
            }
            if (result.length > 0) {
                winSymbolsRightTl.add(result, `<${delay}`);
            }
        }
        // if we dont have any left to right wins or are doing a both ways win the timings are fine
        // however if we have a left to right win seperate from the right to left wins there is a slight delay
        // between the left to right and right to left wins
        if (!isBothWays && leftLines.length > 0) {
            const longestLine = leftToRightSymbols.filter((reel) => reel.length > 0).length;
            tl.add(winSymbolsRightTl, `<${(longestLine + 2) * delay}`);
        } else {
            tl.add(winSymbolsRightTl);
        }

        if (!TheCage.model.gameData.brokeTheBank){
            // wins
            if (winLineAmountData.length > 0) {
                tl.add(() => {TheCage.winView.playLineWinDisplays(winLineAmountData, isBothWays ? 2 : 1)}, '>-0.25');
            }
            if (isBothWays) {
                tl.add(() => {}, '>1.5');
                tl.add(() => TheCage.soundPlayer.playSound(TheCageSound.WIN_BOTHWAYS_EXPLODE));
            }

            // explode
            const winExplosionsLeft = gsap.timeline();
            for (let i = 0; i < 4; i++) {
                const result: gsap.core.Timeline[] = [];
                //Reverse to add the symbols bottom to top.
                for (let sym of winSymbols[i]) {
                    if ((<TheCageSymbol>sym.positionable).symbolName != "WS") {
                        result.push((<TheCageSymbol>sym.positionable).getStateAnimation(winExplosion));
                        sym.removed = true
                    }
                }
                winExplosionsLeft.add(result, `<${delay}`);
            }
            tl.add(winExplosionsLeft);

            const winExplosionsRight = gsap.timeline();
            for (let i = 0; i < 5; i++) {
                const result: gsap.core.Timeline[] = [];
                //Reverse to add the symbols bottom to top.
                for (let sym of winSymbols[8 - i]) {
                    if ((<TheCageSymbol>sym.positionable).symbolName != "WS") {
                        result.push((<TheCageSymbol>sym.positionable).getStateAnimation(winExplosion));
                        sym.removed = true
                    }
                }
                winExplosionsRight.add(result, `<${delay}`);
            }
            tl.add(winExplosionsRight, '<');
        }

        // darkening stuff, why is this at the end :woozy:
        tl.add(SymbolUtils.getSymbolStateAnimations(noWinSymbols, TheCageSymbolStates.NORMAL),"<0.2");
        if (winSymbols[0].length > 0 || winSymbols[8].length > 0){
            tl.add(SymbolUtils.getSymbolStateAnimations(noWinSymbols, TheCageSymbolStates.NO_WIN), 0);
        }
        if (winSymbols[0].length > 0 && winSymbols[8].length > 0) {
            rightToLeftSymbols.forEach((reel) => {
                tl.add(SymbolUtils.getSymbolStateAnimations(reel, TheCageSymbolStates.NO_WIN), 0);
            })
        }
        return tl;
    }

    protected playWinSound(winConfigs: WinConfig[], belowStakeWinRestriction: boolean, tl: gsap.core.Timeline) {
        const lastLevelConfig:WinConfig = winConfigs[winConfigs.length - 1].clone();
        if (lastLevelConfig.sound?.init && !belowStakeWinRestriction && TheCage.model.winData.lines.length > 0) {
            this.winSound = "";
            this.winSound = lastLevelConfig.sound?.init!;
        }
        if (lastLevelConfig.sound?.sweep && !belowStakeWinRestriction && TheCage.model.winData.lines.length > 0) {
            this.winSweep = "";
            this.winSweep = lastLevelConfig.sound?.sweep!;
        }
    }
}